export default __webpack_public_path__ + "static/media/inc_ticket.d47c363d.svg";